import { Grid, createStyles, makeStyles } from "@material-ui/core";
import dynamic from "next/dynamic";
const SignupForm = dynamic(() => import("./components/signup-form"));
const RealEstateInfo = dynamic(() => import("./components/real-estate-info"));

const useStyles = makeStyles(theme =>
    createStyles({
        cardBackground: {
            display: "flex",
            minHeight: "100vh",
            background: "url('/imgs/bgn.jpg') no-repeat",
            backgroundSize: "cover",
            backgroundColor: theme.palette.primary.main + "ee",
            backgroundBlendMode: "multiply",
            [theme.breakpoints.down("sm")]: {
                minWidth: "100vw",
                background: "white",
                minHeight: 1
            }
        },
        rootPresentationContainer: {
            [theme.breakpoints.down("sm")]: {
                marginTop: theme.spacing(8)
            }
        }
    })
);

const SignupRealEstate = ({ ...props }) => {
    const classes = useStyles();

    return (
        <Grid container justifyContent={"space-evenly"} alignItems={"center"} style={{ margin: "0px", display: "flex", width: "100vw" }}>
            <Grid
                container
                item
                xs={12}
                md={6}
                justifyContent="center"
                alignItems="center"
                direction={"column"}
                className={classes.rootPresentationContainer}
            >
                <RealEstateInfo {...props} />
            </Grid>
            <Grid container item xs={6} justifyContent={"center"} alignItems={"center"} className={classes.cardBackground}>
                <SignupForm {...props} />
            </Grid>
        </Grid>
    );
};

export default SignupRealEstate;
